<script>
import Vue from 'vue'

export default {
    install(Vue){
        Vue.filter('localeDate', date => {
            let dateObj = new Date(date)
            return dateObj.toLocaleDateString('ru-Ru', { year:'numeric', month:'long', day:'numeric' })
        })
    }
}
</script>